import api from './axiosConfig';
export const getSabangnetOrders = async (startDate, endDate) => {
    try {
        const response = await api.get(`/api/sabangnet/order`, {
            params: { startDate, endDate }
        });
        return response.data;
    }
    catch (error) {
        console.error('사방넷 주문 조회 중 오류 발생:', error);
        throw error;
    }
};
